// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3hMc9","actionsCol":"EnrolledClinics_actionsCol__wHovG"};